import { combineReducers } from 'redux';
import feedReducer from './feedReducer';
import {modalReducer} from './modalReducer';
import storyReducer from './storyReducer';
import exploreReducer from './exploreReducer';
import fleekStateReducer from './fleekStateReducer';
import webMetaData from '../../reducers/shared/webMetaData';
import brandsPageReducer from './brandsPageReducer';
import popup from '../../reducers/shared/Popup'
import mobileBottomNavReducer from '../../reducers/mobile/mobileBottomNavReducer';

const fleekRootReducer = combineReducers({
     feed: feedReducer,
     story: storyReducer,
     modal: modalReducer,
     explore: exploreReducer,
     state: fleekStateReducer,
     metaData: webMetaData,
     brandsPage: brandsPageReducer,
     popup: popup,
     bottomNavList: mobileBottomNavReducer
});

export default fleekRootReducer;
